export const novelMeta = {
  name: "迷人的保姆",
  author: "温南枝",
  category: "都市情感",
  status: "已完结",
  chapterCount: "1,286 章",
  words: "约 218 万字",
  updated: "2026-09-28",
  tags: ["都市", "情感", "成长", "治愈", "群像"],
};

export const heroStats = [
  { label: "收录章节", value: "1,286 章" },
  { label: "连载字数", value: "218 万字" },
  { label: "读者评分", value: "9.4 / 10" },
  { label: "最近更新", value: "2026-09-28" },
];

export const novelIntro = {
  paragraphs: [
    "《迷人的保姆》的故事从一间洒满午后阳光的老宅开始。主人公林晚为了照顾年迈的外婆，接下了人生中第一份住家保姆的工作，也因此走进了一座秩序井然、却各自藏着心事的大家庭。",
    "从厨房到客厅，从清晨的一碗粥到深夜还亮着的一盏灯，林晚用一双勤恳的手，慢慢熨平了这个家里被岁月揉皱的关系。她不是故事里最耀眼的那个人，却是所有线索悄悄汇聚的地方。",
    "小说以细密的日常为骨，以人物缓慢的成长与和解为魂，写尽了平凡生活里的温度与分寸。有人读到了治愈，有人读到了成年人之间的体面与克制。",
  ],
  info: [
    { label: "作品名", value: "迷人的保姆" },
    { label: "作者", value: "温南枝" },
    { label: "类别", value: "都市情感" },
    { label: "状态", value: "已完结 · 含番外" },
    { label: "连载字数", value: "约 218 万字" },
    { label: "最近更新", value: "2026-09-28" },
  ],
};

export const readingEntries = [
  {
    icon: "ri-book-open-line",
    title: "在线看全文",
    desc: "打开即读，按卷逐章浏览，自动记住最近读到的那一章。",
    action: "进入在线阅读",
    note: "共 1,286 章",
  },
  {
    icon: "ri-download-2-line",
    title: "txt 下载",
    desc: "整合校对的 txt 全集，手机与电脑都能一键保存，方便离线阅读。",
    action: "下载 txt 全集",
    note: "约 6.2 MB",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "无删减版",
    desc: "对照原稿补齐的完整版本，段落完整、排版干净，读起来更连贯。",
    action: "查看无删减版",
    note: "完整收录",
  },
];

export const chapterVolumes = [
  {
    title: "第一卷 · 初入深宅",
    type: "main",
    chapters: [
      {
        no: "第001章",
        title: "一碗热粥的距离",
        summary: "林晚拎着行李第一次走进程家老宅，也第一次尝到了这座宅子里说不清的客气。",
        words: "3,120 字",
        updated: "2026-08-02",
        hot: true,
      },
      {
        no: "第002章",
        title: "客厅里的规矩",
        summary: "从摆放茶具的顺序到说话的分寸，管家递来的那份守则比她想象中要厚得多。",
        words: "2,980 字",
        updated: "2026-08-03",
        hot: false,
      },
      {
        no: "第003章",
        title: "楼上那扇门",
        summary: "二楼最里头那扇门常年关着，宅子里的每个人经过时都会不自觉放轻脚步。",
        words: "3,340 字",
        updated: "2026-08-05",
        hot: false,
      },
      {
        no: "第004章",
        title: "暴雨夜的孩子",
        summary: "夜里孩子高烧不退，林晚抱着他跑过整条巷子，敲开了唯一一家还亮着灯的诊所。",
        words: "3,760 字",
        updated: "2026-08-07",
        hot: true,
      },
      {
        no: "第005章",
        title: "迟来的道歉",
        summary: "一句憋了很久的对不起，终于在一顿安静的晚饭之后说出了口。",
        words: "3,010 字",
        updated: "2026-08-09",
        hot: false,
      },
      {
        no: "第006章",
        title: "旧相册",
        summary: "整理阁楼时翻出来的旧相册，让程家埋了多年的那件事重新浮出水面。",
        words: "3,280 字",
        updated: "2026-08-11",
        hot: false,
      },
    ],
  },
  {
    title: "第二卷 · 各自心事",
    type: "main",
    chapters: [
      {
        no: "第007章",
        title: "各自的抽屉",
        summary: "每个人心里都有一台上锁的抽屉，钥匙握在谁手上，谁也说不清。",
        words: "3,150 字",
        updated: "2026-08-14",
        hot: false,
      },
      {
        no: "第008章",
        title: "一场家宴",
        summary: "满桌的菜配着满桌的笑，唯独少了那个最该在场的人。",
        words: "3,420 字",
        updated: "2026-08-17",
        hot: true,
      },
      {
        no: "第009章",
        title: "深夜的电话",
        summary: "凌晨两点的一通电话，把林晚从厨房里的安稳日子一下子拽了出去。",
        words: "2,860 字",
        updated: "2026-08-20",
        hot: false,
      },
      {
        no: "第010章",
        title: "菜市场的清晨",
        summary: "天还没亮，她陪外婆在菜市场挑菜，忽然想明白了自己留下来的理由。",
        words: "3,070 字",
        updated: "2026-08-23",
        hot: false,
      },
      {
        no: "第011章",
        title: "不再沉默",
        summary: "沉默是一种体面，但有时候，愿意开口才是真正的体面。",
        words: "3,530 字",
        updated: "2026-08-26",
        hot: false,
      },
    ],
  },
  {
    title: "番外 · 后来的日子",
    type: "extra",
    chapters: [
      {
        no: "番外一",
        title: "那年冬天的雪",
        summary: "很多年以后，他们都还记得老宅门口那场下了一整夜的雪。",
        words: "4,120 字",
        updated: "2026-09-20",
        hot: false,
      },
      {
        no: "番外二",
        title: "厨房的灯还亮着",
        summary: "无论多晚回家，总有一盏灯和一碗汤在等着你。",
        words: "3,640 字",
        updated: "2026-09-24",
        hot: false,
      },
      {
        no: "番外三",
        title: "写给林晚的信",
        summary: "那些没能当面说出口的话，都写进了这封始终没有寄出的信里。",
        words: "3,980 字",
        updated: "2026-09-28",
        hot: true,
      },
    ],
  },
];

export const reviews = [
  {
    name: "半盏清茶",
    initial: "清",
    rating: 5,
    time: "3 天前",
    text: "看完整本最大的感受是：它没有急着讲一个惊心动魄的故事，而是把日子一天天摊开给你看。林晚这个人物立住了，那种不声不响的坚韧特别打动人。",
    likes: 1286,
    replies: 96,
    hot: true,
  },
  {
    name: "临江听雨",
    initial: "雨",
    rating: 5,
    time: "1 周前",
    text: "文笔干净，细节扎实。厨房、餐桌、老宅的巷子，都写得很有味道。看到暴雨夜那一章是真的没忍住。",
    likes: 842,
    replies: 41,
    hot: true,
  },
  {
    name: "南巷阿柚",
    initial: "柚",
    rating: 4,
    time: "2 周前",
    text: "前面节奏偏慢，但熬过前十章之后就完全停不下来。番外写得尤其好，像给角色的人生补上了温柔的一笔。",
    likes: 537,
    replies: 23,
    hot: false,
  },
  {
    name: "读小说的老周",
    initial: "周",
    rating: 5,
    time: "2 周前",
    text: "难得见到把群像写得这么稳的都市文，每个人都有自己的逻辑和难处，没有工具人。已经推荐给好几个朋友了。",
    likes: 664,
    replies: 35,
    hot: true,
  },
  {
    name: "晚风信箱",
    initial: "晚",
    rating: 5,
    time: "3 周前",
    text: "txt 排版很舒服，晚上用手机看也不累眼。希望后面还能再出一些番外，实在舍不得看完。",
    likes: 308,
    replies: 12,
    hot: false,
  },
  {
    name: "拾光记事",
    initial: "拾",
    rating: 4,
    time: "1 个月前",
    text: "无删减版确实完整不少，有些段落之前完全没读过，连起来看顺畅很多。属于越读越上头的那一类。",
    likes: 452,
    replies: 19,
    hot: false,
  },
];

export const ratingSummary = {
  score: "9.4",
  outOf: "10",
  total: "3,268 条书评",
  distribution: [
    { star: 5, percent: 78 },
    { star: 4, percent: 15 },
    { star: 3, percent: 5 },
    { star: 2, percent: 1 },
    { star: 1, percent: 1 },
  ],
};

export const faqs = [
  {
    q: "《迷人的保姆》一共多少章，完结了吗？",
    a: "小说目前共收录 1,286 章，已完结，包含正文卷与番外篇。全文阅读入口与章节列表都可以在本页直接找到，无需跳转其他站点。",
  },
  {
    q: "可以在线看吗，一定要先下载吗？",
    a: "完全可以。在线看支持逐章阅读，打开即读；如果你更习惯离线阅读，也可以选择 txt 全集下载，两种方式的内容完全一致。",
  },
  {
    q: "下载的 txt 是完整无删减的吗？",
    a: "本页整理的 txt 全集对照原稿补齐，段落完整、排版清晰，属于完整无删减版本，章节顺序与正文保持一致。",
  },
  {
    q: "如何快速找到想看的某一章？",
    a: "在章节目录里可以直接搜索章节标题或关键词，也可以按正文卷、番外篇切换分类，快速定位到对应的阅读入口。",
  },
  {
    q: "阅读进度会自动保存吗？",
    a: "在线看模式下会记录你最近阅读到的章节，方便下次接着往下读；下载到本地的 txt，则由你使用的阅读软件来记录进度。",
  },
];